export default class Model {
	constructor(panelItems, pluses, engines, navigation) {
		this._panelItems = panelItems;
		this._pluses = pluses;
		this._engines = engines;
		this._navigation = navigation;
	}

	get panelItems() {
		return this._panelItems;
	}

	get pluses() {
		return this._pluses;
	}

	get engines() {
		return this._engines;
	}

	get navigation() {
		return this._navigation;
	}

	get navigationItems() {
		return this._navigation.map((nav) => ({
			...nav,
			panelItems: nav.panelItems
				.map((id) => this.panelItems.find((panel) => panel.id === id))
				.filter(Boolean),
		}));
	}
}
